/** Responsive width classes for auth form elements (submit button, inputs). */
export const AUTH_FORM_WIDTH = 'w-full fold:w-[90%] md:w-[385px] 4xl:w-full';
